import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

/** Bootstraps /me once on app mount — blocks rendering routes until resolved. */
export function AuthBootstrap({ children }: { children: React.ReactNode }) {
  const loaded = useAuth((s) => s.loaded);
  const bootstrap = useAuth((s) => s.bootstrap);
  useEffect(() => { bootstrap(); }, [bootstrap]);
  if (!loaded) {
    return (
      <div className="flex min-h-dvh items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }
  return <>{children}</>;
}

/** Redirect to /login if not signed in. */
export function RequireAuth() {
  const user = useAuth((s) => s.user);
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}

/** If signed in, skip marketing/auth and go to /app. */
export function RequireAnon() {
  const user = useAuth((s) => s.user);
  if (user) return <Navigate to="/app" replace />;
  return <Outlet />;
}
